import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const getLetters = () => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/smByIcc/letters',
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_LETTERS,
        ActionTypes.FETCHED_LETTERS,
        [
          ActionTypes.FETCHED_LETTERS_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const getIccStock = (year, month) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/smByIcc/stock/${year}/year/${month}/month`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_ICC_STOCK,
        ActionTypes.FETCHED_ICC_STOCK,
        [
          ActionTypes.FETCHED_ICC_STOCK_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const getIccSales = (year, month) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/smByIcc/sales/${year}/year/0${month}/month`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_ICC_SALES,
        ActionTypes.FETCHED_ICC_SALES,
        [
          ActionTypes.FETCHED_ICC_SALES_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};
